// AWS dev環境用設定（デプロイ済みのdev環境APIに接続）
export const environment = {
  production: false,
  // API の入口は CloudFront (WAF + オリジン直叩き封鎖) に統一されている (Issue #472)。
  // 旧 execute-api 直 URL (kmjfgm1ufg.execute-api...) は封鎖予定のため参照しないこと。
  // このドメインは infra 側 `terraform output cloudfront_url` と一致させる。
  apiUrl: 'https://d1mbzpe2loxiac.cloudfront.net/api/v0',
  useMock: false,
  // ポーリング間隔（ミリ秒）
  pollingIntervalMs: 15_000,
  // ファイル処理ステータスポーリング間隔（ミリ秒）
  filePollingIntervalMs: 15_000,
  cognito: {
    userPoolId: 'ap-northeast-1_LCYVIjlX3',
    clientId: '215f81g4go7poe1rgnb2pfama3',
    // 認証アプリに表示される名称。同一ユーザーが複数環境に登録するため環境名を含める
    totpIssuer: '[dev] Kagua for Adecco',
  },
  // OpenTelemetry 設定。viewer が trace の root となるため、この samplingRatio が
  // viewer → api-server → AI Server/DB 全体のサンプリング率を実質的に支配する
  // （backend は ParentBasedSampler で親の判定を継承する）。トレース量・コスト制御のノブ。
  otel: { samplingRatio: 1.0 },
};
